import * as React from "react"
import { observer } from "mobx-react"
import { WaiverEditor } from "./WaiverEditor"
import { Box, Heading, Flex, Text } from "rebass"
import ToggleSwitch from "../../components/ToggleSwitch"
import StyledCard from "../../components/StyledCard"
import theme from "../../theme"

@observer
export class WaiverMembersCard extends React.Component<{
  model: WaiverEditor
}> {
  componentDidMount() {
    this.props.model.componentDidMount()
  }
  componentWillUnmount() {
    this.props.model.componentWillUnMount()
  }
  render() {
    const { model } = this.props

    return (
      <StyledCard
        width={["94vw", "80vw", "53vw"]}
        mr={["1%"]}
        ml={["1%"]}
        mt={["1%"]}
        mb={["1%"]}
        bg={theme.colors.black}
        style={{ fontSize: "1.25rem", fontWeight: 800 }}
      >
        <Box width={["93vw", "78vw", "100%"]}>
          {model.numOfMinors > 0 && (
            <Flex
              flexDirection="row"
              alignItems="center"
              width={1}
              style={{ height: 50 }}
            >
              <Text
                width={1}
                m={1}
                fontSize={["0.8rem", "1.25rem", "1.5rem"]}
                fontWeight={600}
                textAlign="center"
                style={{ fontStyle: "italic" }}
              >
                Add minors to
              </Text>
            </Flex>
          )}
          <Heading
            mb={"2%"}
            fontSize={["1.5rem", "1.75rem", "2rem"]}
            textAlign="center"
          >
            {`${model.name}'s Waiver`}
          </Heading>
        </Box>
        {model.numOfMinors > 0 ? (
          <Box>
            {model.numOfMembers === 0 ? (
              <Box />
            ) : (
              <Flex flexDirection="column">
                <Flex flexDirection="column">
                  {model.flow.currentBooking.minorsNeedingWaiver.map(
                    (minor, i) => {
                      return (
                        <Flex
                          key={i}
                          flexDirection="row"
                          alignItems="center"
                          justifyContent="center"
                          width={1}
                          style={{ height: 50 }}
                        >
                          <Flex
                            width={[0.33, 0.2, 0.2]}
                            alignItems="center"
                            m={1}
                            justifyContent="center"
                            style={{ height: 50 }}
                          >
                            <ToggleSwitch
                              type="checkbox"
                              className="toggle"
                              checked={model.has(minor)}
                              onClick={() => {
                                model.toggleMembership(minor)
                              }}
                            />
                          </Flex>
                          <Flex
                            m={1}
                            width={[1]}
                            style={{ height: 50 }}
                            justifyContent="flex-start"
                            alignItems="center"
                          >
                            <Text
                              fontSize={["0.8rem", "1.25rem", "1.5rem"]}
                              fontWeight={600}
                            >
                              {`${minor.fullName}`}
                            </Text>
                          </Flex>
                        </Flex>
                      )
                    }
                  )}
                </Flex>
              </Flex>
            )}
          </Box>
        ) : (
          <div />
        )}
        <footer
          style={{
            marginTop: model.minorsNeedingWaiver.length > 0 ? "3%" : "1%"
          }}
        >
          <a
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: model.readyToSign ? theme.colors.white : theme.colors.grey,
              background: model.readyToSign
                ? theme.colors.sign
                : theme.colors.darkgrey,
              height: "5vh"
            }}
            onClick={() => {
              if (model.readyToSign) {
                model.showSignModal()
              } else alert("Please select a member to sign for.")
            }}
          >
            <i className="fas fa-pen" style={{ marginRight: "3%" }} />
            {model.isSigned ? "Signed" : "Sign"}
          </a>
        </footer>
      </StyledCard>
    )
  }
}
